export enum DeliveryPayerEnum {
  RECIPIENT = 'recipient',
  SENDER = 'sender',
}
